import React from 'react';

const SourceLink = (props:any) => {
  /* eslint-disable jsx-a11y/anchor-has-content */
  return (
    <a href="/" target="_blank" rel="noopener noreferrer" {...props} />
  );
};

export default SourceLink;
